import { 
    GET_ADS,
    SET_ADS,
    SET_LAST_ADS,
    AD_ERROR,
    CLEAR_ADS,
    ADS_LOADING,
    GET_AD
} from "../actions/types";

const initialState = {
    ads: [],
    ad: null,
    no_more_ads: false,
    loading: true,
    error: {}
}

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case ADS_LOADING:

            // Set the loading state to true
            return {
                ...state,
                loading: true
            };
        case GET_ADS:

            // Set the ads state to the payload value,
            return {
                ...state,
                ads: payload,
                loading: false
            }
        case SET_ADS: {

            // Merge the existing ads with the payload ads,
            // and update the ads state accordingly
            const ads = action.payload;
            let tempAds = ads; 
            
            if(state.ads.length > 0) {
                tempAds= [...state.ads, ...tempAds ];
            }

            return {
                ...state,
                ads: tempAds,
                loading: false
            };
        }
        case SET_LAST_ADS: {

            // Merge the existing ads with the payload ads, and update the ads state
            const ads = action.payload;
            let tempAds = ads; 
            
            if(state.ads.length > 0) {
                tempAds= [...state.ads, ...tempAds ];
            }

            return {
                ...state,
                ads: tempAds,
                no_more_ads: true,
                loading: false
            };
        }
        case AD_ERROR:

            // Set the error state to the payload value and set loading to false
            return {
                ...state,
                error: payload,
                loading: false,
            };
        case CLEAR_ADS:

            // Clear the ads state and set loading to false
            return {
                ...state,
                ads: [],
                loading: false,
            }
        case GET_AD:
        
            // Set the ad state to the payload value and set loading to false
            return {
                ...state,
                ad: payload,
                loading: false
            }
        default:
            return state;
    }
}